var E = /* @__PURE__ */ ((L) => (L[L.DEV = 0] = "DEV", L[L.LIVE = 1] = "LIVE", L[L.LOCALSERVER = 2] = "LOCALSERVER", L[L.NEXT = 3] = "NEXT", L[L["PRE-PRELEASE"] = 4] = "PRE-PRELEASE", L[L.TEST = 5] = "TEST", L))(E || {}), R = /* @__PURE__ */ ((L) => (L[L.DEV = 0] = "DEV", L[L.LIVE = 1] = "LIVE", L[L.LOCALSERVER = 2] = "LOCALSERVER", L[L.NEXT = 3] = "NEXT", L))(R || {});
export {
  R as BackendEnvironment,
  E as FrontendEnvironment
};
